import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import IconWrapper from "./icon-wrapper.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'visibility-icon',
  setup(__props) {

const icon = '<span class="material-icons">visibility</span>';

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(IconWrapper, { iconHtml: icon }))
}
}

})